export const arrivalObj = (obj, key) => ({
  val: obj[key] || '',
  validationKey: `arrival_${key}`,
  profileElement: true
})

export const pickupObj = (obj, key) => ({
  val: obj[key] || '',
  validationKey: `pickup_${key}`,
  profileElement: true
})

export const ameOrUsa = (territory) => (
  territory.code == 'SRSC' || territory.code == 'USA'
)
